import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  CardGroup,
  Table,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { TiPrinter } from "react-icons/ti";
import {
  getAllPassports,
  resetPassportList,
  getPassportById,
  deletePassport,
  resetPassportDelete,
} from "../features/passport/passportSlice";
import { getAllAgents } from "../features/agent/agentSlice";
import { getAllOffices } from "../features/deliveryoffice/officeSlice";
import { getAllEmployees } from "../features/employee/employeeSlice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Print from "../components/PassportListPrint";
import { logout } from "../features/user/userSlice";

// Font.register({
//   family: "Open Sans",
// });

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: "38",
  },
  section: {
    // margin: 20,
    // padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#3c8dbc",
    textAlign: "center",
    marginBottom: 10,
    fontFamily: "Helvetica-Bold",
  },
  header: {
    // family: "Open Sans",
    fontSize: 12,
    // fontWeight: "bold",
    // fontWeight: "1000",
    textAlign: "center",
    margin: 20,
    fontFamily: "Helvetica-Bold",
  },
  address: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 10,
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // bottom: -100,
    // width: "20%",
    // position: "absolute",
  },
  signatureLeft: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "center",
    fontFamily: "Helvetica",
    justifyContent: "flex-start",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  signatureRight: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "right",
    fontFamily: "Helvetica",
    justifyContent: "flex-end",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  line: {
    border: "1px dashed black",
    borderRadius: "1px",
    width: "150%",
  },
  table: {
    // display: "table",
    // width: "100%",
    // borderStyle: "dotted",
    // borderWidth: 1,
    // borderCollapse: "collapse",
    // borderBottom: 1,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    borderStyle: "dotted",
  },
  tableCell: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
    fontFamily: "Helvetica-Bold",
  },

  tableData: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
  },

  agentName: {
    // displayL: "table",
    // fontFamily: 'Open Sans',
    // width: "auto",
    fontSize: 10,
    fontWeight: 600,
    textAlign: "left",
    borderStyle: "dotted",
    borderWidth: 1,
    borderCollapse: "collapse",
    paddingLeft: 15,
    paddingBottom: 5,
    paddingTop: 5,
    marginBottom: 20,
  },
});

const PassportList = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const [printPreview, setPrintPreview] = useState(false);

  const [allPassports, setAllPassports] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const [allOffices, setAllOffices] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);

  const [searchByName, setSearchByName] = useState("");
  const [searchByPassportNo, setSearchByPassportNo] = useState("");
  const [searchByPassportStatus, setSearchByPassportStatus] = useState("");
  const [searchByCountry, setSearchByCountry] = useState("");
  const [searchByCompany, setSearchByCompany] = useState("");
  const [searchByDeliveryOffice, setSearchByDeliveryOffice] = useState("");
  const [searchByAgent, setSearchByAgent] = useState("");
  const [searchByEmployee, setSearchByEmployee] = useState("");

  const [resultCount, setResultCount] = useState(0);

  // User Selector
  const { userInfo } = useSelector((state) => state.user);

  // Passport Selectors
  const {
    passports,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,

    isDeleteError,
    isDeleteLoading,
    isDeleteSuccess,
    deleteErrorMessage,
  } = useSelector((state) => state.passport);

  // Office Selectors
  const {
    offices,

    isListLoading: isOfficeListLoading,
    isListError: isOfficeListError,
    isListSuccess: isOfficeListSuccess,
    listErrorMessage: listOfficeErrorMessage,
  } = useSelector((state) => state.office);

  // Agent Selectors
  const {
    agents,

    isListLoading: isAgentListLoading,
    isListError: isAgentListError,
    isListSuccess: isAgentListSuccess,
    listErrorMessage: listAgentErrorMessage,
  } = useSelector((state) => state.agent);

  const {
    employees,

    isListLoading: isEmployeeListLoading,
    isListError: isEmployeeListError,
    isListSuccess: isEmployeeListSuccess,
    listErrorMessage: listEmployeeErrorMessage,
  } = useSelector((state) => state.employee);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("passportList") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  // For counting the list
  useEffect(() => {
    setResultCount(allPassports.length);
  }, [allPassports]);

  // Delivery Office List
  useEffect(() => {
    if (isOfficeListError) {
      // toast.error(listOfficeErrorMessage, { position: "top-center" });
    } else if (isOfficeListSuccess) {
      setAllOffices(offices);
    } else {
      dispatch(getAllOffices());
    }
  }, [
    dispatch,
    isOfficeListError,
    isOfficeListSuccess,
    // listOfficeErrorMessage,
    offices,
  ]);

  // Agent List
  useEffect(() => {
    if (isAgentListError) {
      // toast.error(listAgentErrorMessage, { position: "top-center" });
    } else if (isAgentListSuccess) {
      setAllAgents(agents);
    } else {
      dispatch(getAllAgents());
    }
  }, [
    dispatch,
    isAgentListError,
    isAgentListSuccess,
    // listAgentErrorMessage,
    agents,
  ]);

  //Employee List
  useEffect(() => {
    if (isEmployeeListError) {
      // toast.error(listEmployeeErrorMessage, { position: "top-center" });
    } else if (isEmployeeListSuccess) {
      setAllEmployees(employees);
    } else {
      dispatch(getAllEmployees());
    }
  }, [dispatch, isEmployeeListError, isEmployeeListSuccess, employees]);

  // State to store filtered passports
  const [filteredPassports, setFilteredPassports] = useState([]);

  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      const filtered = passports
        .filter((passport) => {
          if (searchByName === "") {
            return passport;
          } else {
            return passport.fullName
              .toLowerCase()
              .includes(searchByName.toLowerCase());
          }
        })
        .filter((passport) => {
          if (searchByPassportNo === "") {
            return passport;
          } else {
            return passport.passportNumber
              .toLowerCase()
              .includes(searchByPassportNo.toLowerCase());
          }
        })
        .filter((passport) => {
          if (searchByCountry === "") {
            return passport;
          } else {
            return passport.country
              .toLowerCase()
              .includes(searchByCountry.toLowerCase());
          }
        })
        .filter((passport) => {
          if (searchByCompany === "") {
            return passport;
          } else {
            return passport.company
              .toLowerCase()
              .includes(searchByCompany.toLowerCase());
          }
        })
        .filter((passport) => {
          if (searchByAgent === "") {
            return passport;
          } else {
            return passport.agent
              .toLowerCase()
              .includes(searchByAgent.toLowerCase());
          }
        })
        .filter((passport) => {
          if (searchByDeliveryOffice === "") {
            return passport;
          } else {
            return passport.deliveryOffice
              .toLowerCase()
              .includes(searchByDeliveryOffice.toLowerCase());
          }
        });

      // Set filtered passports in state
      setFilteredPassports(filtered);
      setResultCount(filtered.length);
    } else {
      dispatch(getAllPassports());
    }
  }, [
    dispatch,
    isListError,
    isListSuccess,
    listErrorMessage,
    searchByName,
    searchByPassportNo,
    searchByCountry,
    searchByCompany,
    searchByDeliveryOffice,
    searchByAgent,
    passports,
  ]);

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Passport Deleted Successfully", {
        position: "top-center",
      });
    }
  }, [isDeleteError, deleteErrorMessage, isDeleteSuccess]);

  useEffect(() => {
    // Dispatch when the component is mounted
    // dispatch(resetPassportList());
    // dispatch(getAllPassports({ page: 1 }));

    // Cleanup when the component is unmounted
    return () => {
      dispatch(resetPassportList());
      dispatch(resetPassportDelete());
    };
  }, []);

  // useEffect(() => {
  //   dispatch(getAllPassports(page));
  // }, [page]);

  const handleDelete = (id) => {
    if (window.confirm("Are You Sure You Want To Delete?")) {
      dispatch(deletePassport(id));
      dispatch(resetPassportList());
    }
  };

  // pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 30;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = filteredPassports.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filteredPassports.length / recordsPerPage); // Total pages
  const numbers = [...Array(npage + 1).keys()].slice(1);

  return (
    <>
      {printPreview ? (
        <>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document>
              <Page size="A4" style={styles.page} orientation="landscape">
                <View style={styles.section}>
                  <Text style={styles.title}>Northeast Overseas LTD.</Text>
                  <Text style={styles.address}>
                    Gulfesha Plaza, 12/0, 69 Outer Circular Road, Boro Mogbazar,
                    Dhaka-1217
                  </Text>
                  <Text style={styles.address}>
                    Phone: +880241031411-2 || Email: info@northeastoverseas.com
                  </Text>

                  <Text style={styles.header}>PASSPORT LIST</Text>

                  {/* <Text style={styles.agentName}>
                    {allPassports?.map((passport) => (
                      <Text key={passport._id}>
                        Agent: {passport.agent}
                        {"\n"}
                        Delivery Office: {passport.deliveryOffice}
                      </Text>
                    ))}
                  </Text> */}
                  <Text style={styles.agentName}>
                    <Text style={{ fontFamily: "Helvetica-Bold" }}>
                      Agent:{" "}
                    </Text>{" "}
                    {searchByAgent}
                    {"\n"} {"\n"}
                    <Text style={{ fontFamily: "Helvetica-Bold" }}>
                      Delivery Office:{" "}
                    </Text>{" "}
                    {searchByDeliveryOffice}
                  </Text>

                  <View style={styles.tableContainer}>
                    <View style={styles.table}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCell}>
                          <Text>SL</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Name</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Passport No.</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Contact No.</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Country</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Employee</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Agent</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Contract</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Status</Text>
                        </View>
                      </View>
                      {filteredPassports.map((passport, index) => (
                        <View style={styles.tableRow} key={index}>
                          <View style={styles.tableData}>
                            <Text>{index + 1}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.fullName}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.passportNumber}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.phone}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.country}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.officeAgent}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.agent}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.contractAmount}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{passport.status}</Text>
                          </View>
                        </View>
                      ))}
                    </View>
                  </View>

                  {/* Signature Section */}
                  <View style={styles.footer}>
                    <View style={styles.row}>
                      <View style={styles.signatureLeft}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Agent Signature
                        </Text>
                      </View>

                      <View style={styles.signatureRight}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Authorized Signature
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
          <Button variant="danger" onClick={() => setPrintPreview(false)}>
            Cancel
          </Button>
        </>
      ) : (
        <Container fluid className="my-4">
          <>
            {/* <h2 style={{ fontWeight: "bold " }} className="mb-4 text-center">
              All Passport List
            </h2> */}

            <Row className="mb-4">
              <Card
                className="rounded-4 border"
                style={{ backgroundColor: "#e6edf1" }}
              >
                <h2 className="my-3 text-dark text-center fw-bold">
                  All <span style={{ color: "#5c91dc" }}>Passport</span> List
                </h2>
              </Card>
            </Row>

            {isListLoading ||
            isOfficeListLoading ||
            isAgentListLoading ||
            isEmployeeListLoading ? (
              <Loader />
            ) : (
              <>
                <Row>
                  {/* Search Options */}
                  <CardGroup className="mb-3 p-0">
                    <Card>
                      <Card.Header
                        className="text-center text-black fw-bold"
                        style={{ backgroundColor: "#74a2e3" }}
                        as="h6"
                      >
                        Search By Name
                      </Card.Header>
                      <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                        <Form>
                          <Form.Control
                            type="text"
                            placeholder="Enter Name"
                            name="searchByName"
                            // value={searchByName}
                            onChange={(e) => setSearchByName(e.target.value)}
                            className="shadow-rounded"
                          ></Form.Control>
                        </Form>
                      </Card.Body>
                    </Card>

                    <Card>
                      <Card.Header
                        className="text-center fw-bold text-black"
                        style={{ backgroundColor: "#74a2e3" }}
                        as="h6"
                      >
                        Search By Passport
                      </Card.Header>
                      <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                        <Form>
                          <Form.Control
                            type="text"
                            placeholder="Enter Passport No."
                            name="searchByPassportNo"
                            value={searchByPassportNo}
                            onChange={(e) =>
                              setSearchByPassportNo(e.target.value)
                            }
                            className="shadow-rounded"
                          ></Form.Control>
                        </Form>
                      </Card.Body>
                    </Card>

                    <Card>
                      <Card.Header
                        className="text-center fw-bold text-black"
                        style={{ backgroundColor: "#74a2e3" }}
                        as="h6"
                      >
                        Search By Country
                      </Card.Header>
                      <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                        <Form>
                          <Form.Control
                            // as="select"
                            type="text"
                            placeholder="Search By Country"
                            name="searchByCountry"
                            value={searchByCountry}
                            onChange={(e) => setSearchByCountry(e.target.value)}
                            className="shadow-rounded"
                          ></Form.Control>
                        </Form>
                      </Card.Body>
                    </Card>

                    <Card>
                      <Card.Header
                        className="text-center fw-bold text-black"
                        as="h6"
                        style={{ backgroundColor: "#74a2e3" }}
                      >
                        Search By Company
                      </Card.Header>
                      <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                        <Form>
                          <Form.Control
                            type="text"
                            placeholder="Search By Company"
                            name="searchByCompany"
                            value={searchByCompany}
                            onChange={(e) => setSearchByCompany(e.target.value)}
                            className="shadow-rounded"
                          ></Form.Control>
                        </Form>
                      </Card.Body>
                    </Card>

                    <Card>
                      <Card.Header
                        className="text-center fw-bold text-black"
                        as="h6"
                        style={{ backgroundColor: "#74a2e3" }}
                      >
                        Delivery Office
                      </Card.Header>
                      <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                        <Form>
                          <Form.Control
                            as="select"
                            type="select"
                            placeholder="Search By Delivery Office"
                            name="searchByDeliveryOffice"
                            value={searchByDeliveryOffice}
                            onChange={(e) =>
                              setSearchByDeliveryOffice(e.target.value)
                            }
                            className="shadow-rounded"
                          >
                            <option value="">Select Delivery Office</option>
                            {offices.map((office) => (
                              <option value={office.officeName}>
                                {office.officeName}
                              </option>
                            ))}
                          </Form.Control>
                        </Form>
                      </Card.Body>
                    </Card>

                    <Card>
                      <Card.Header
                        className="text-center  text-black fw-bold"
                        as="h6"
                        style={{ backgroundColor: "#74a2e3" }}
                      >
                        Search By Agent
                      </Card.Header>
                      <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                        <Form>
                          <Form.Control
                            as="select"
                            type="select"
                            placeholder="Search By Agent"
                            name="searchByAgent"
                            value={searchByAgent}
                            onChange={(e) => setSearchByAgent(e.target.value)}
                            className="shadow-rounded"
                          >
                            <option value="">Select Agent</option>

                            {agents.map((agent) => (
                              <option value={agent.fullName}>
                                {agent.fullName}
                              </option>
                            ))}
                          </Form.Control>
                        </Form>
                      </Card.Body>
                    </Card>
                  </CardGroup>

                  {/* <Row className="mb-3 mt-2"> */}
                  <Card className="m-2 border-0">
                    <Row>
                      <Col md={6} lg={6}>
                        <h6 className="fw-bold text-dark">
                          Total Showing : {resultCount} Results
                        </h6>
                      </Col>
                      <Col md={6} lg={6} className="d-flex justify-content-end">
                        {/* <LinkContainer to="/printPassportList">
                      <Button
                        variant="outline-success"
                        className="fw-bold"
                        // onClick={() => setPreview(true)}
                      >
                        <TiPrinter className="mb-1" />
                        &nbsp; Print List
                      </Button>
                      </LinkContainer> */}

                        <Button
                          variant="outline-success"
                          className="fw-bold"
                          onClick={() => setPrintPreview(true)}
                        >
                          <TiPrinter className="mb-1" />
                          &nbsp; Print List
                        </Button>
                      </Col>
                    </Row>
                  </Card>

                  {/* Table */}
                  <Card
                    className="shadow"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    <Card.Header
                      className="text-center text-black fw-bold p-2"
                      as="h5"
                      style={{ backgroundColor: "#74a2e3" }}
                    >
                      Passport List
                    </Card.Header>
                    <Table
                      rounded
                      bordered
                      hover
                      responsive
                      style={{ padding: "0px" }}
                    >
                      <thead className="text-center">
                        <tr>
                          <th>No.</th>
                          <th>Name</th>
                          <th>Passport No.</th>
                          <th>Contact Number</th>
                          <th>Country</th>
                          <th>Delivery Office</th>
                          <th>Agent</th>
                          {/* <th>Employee</th> */}
                          <th>Contract</th>
                          <th>Passport Status</th>
                          <th>Edit</th>
                          <th>Delete</th>
                          {/* <th>Print</th> */}
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {records.map((passport, index) => (
                          <>
                            <tr
                              key={`${passport._id}-${index}`}
                              style={{ cursor: "pointer" }}
                            >
                              <td style={{ padding: "0px" }}>
                                {firstIndex + index + 1}
                              </td>
                              <td style={{ padding: "0px" }}>
                                {passport.fullName}
                              </td>
                              <td style={{ padding: "0px" }}>
                                {passport.passportNumber}
                              </td>

                              <td style={{ padding: "0px" }}>
                                {passport.phone}
                              </td>
                              <td style={{ padding: "0px" }}>
                                {passport.country}
                              </td>
                              <td style={{ padding: "0px" }}>
                                {passport.deliveryOffice}
                              </td>
                              <td style={{ padding: "0px" }}>
                                {passport.agent}
                              </td>
                              {/* <td>{passport.officeAgent}</td> */}
                              <td style={{ padding: "0px" }}>
                                {passport.contractAmount}
                              </td>
                              <td style={{ padding: "0px" }}>
                                {/* {passport.status} */}
                                {/* If the passport status is Flight Completed, the color should be green,, otherwise normal */}
                                {passport.status === "Flight Completed" ? (
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {passport.status}
                                  </span>
                                ) : (
                                  passport.status
                                )}
                              </td>

                              {userInfo?.userType === "admin" ? (
                                <>
                                  <td style={{ padding: "0px" }}>
                                    <LinkContainer
                                      to={`/updatePassport/${passport._id}`}
                                    >
                                      <Button className="btn-sm">
                                        <FaEdit />
                                      </Button>
                                    </LinkContainer>
                                  </td>
                                  <td style={{ padding: "0px" }}>
                                    <Button
                                      className="btn-sm"
                                      variant="danger"
                                      onClick={() => handleDelete(passport._id)}
                                    >
                                      <MdDelete />
                                    </Button>
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td style={{ padding: "0px" }}>
                                    {/* <LinkContainer
                                    to={`/updatePassport/${passport._id}`}
                                  > */}
                                    <LinkContainer to="">
                                      <Button className="btn-sm" disabled>
                                        <FaEdit />
                                      </Button>
                                    </LinkContainer>
                                  </td>
                                  <td style={{ padding: "0px" }}>
                                    <Button
                                      className="btn-sm"
                                      variant="danger"
                                      // onClick={() => handleDelete(passport._id)}
                                      disabled
                                    >
                                      <MdDelete />
                                    </Button>
                                  </td>
                                </>
                              )}
                              {/* <td>
                              <Button className="btn-sm" variant="success">
                                <TiPrinter />
                              </Button>
                            </td> */}
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </Table>

                    <nav className="d-flex justify-content-center">
                      <ul className="pagination">
                        <li className="page-item">
                          <a href="#" className="page-link" onClick={prePage}>
                            Prev
                          </a>
                        </li>

                        {/* Show the first two pages */}
                        {numbers.slice(0, 2).map((n, index) => (
                          <li
                            className={`page-item ${
                              currentPage === n ? "active" : ""
                            }`}
                            key={index}
                          >
                            <a
                              href="#"
                              className="page-link"
                              onClick={() => changeCPage(n)}
                            >
                              {n}
                            </a>
                          </li>
                        ))}

                        {/* Show ellipsis if currentPage is beyond page 3 */}
                        {currentPage > 3 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}

                        {/* Show the middle range of pages */}
                        {numbers
                          .slice(
                            Math.max(currentPage - 2, 2),
                            Math.min(currentPage + 1, npage - 1)
                          )
                          .filter((n) => ![1, npage].includes(n)) // Exclude the first and last page from middle range
                          .map((n, index) => (
                            <li
                              className={`page-item ${
                                currentPage === n ? "active" : ""
                              }`}
                              key={index}
                            >
                              <a
                                href="#"
                                className="page-link"
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </a>
                            </li>
                          ))}

                        {/* Show ellipsis if not near the last pages */}
                        {currentPage < npage - 2 && (
                          <li className="page-item disabled">
                            <span className="page-link">...</span>
                          </li>
                        )}

                        {/* Show the last two pages, ensuring they do not repeat */}
                        {numbers.slice(-2).map((n, index) =>
                          n !== 1 &&
                          n !== currentPage &&
                          n !== currentPage - 1 &&
                          n !== currentPage + 1 ? (
                            <li
                              className={`page-item ${
                                currentPage === n ? "active" : ""
                              }`}
                              key={index}
                            >
                              <a
                                href="#"
                                className="page-link"
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </a>
                            </li>
                          ) : null
                        )}

                        <li className="page-item">
                          <a href="#" className="page-link" onClick={nextPage}>
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </Card>
                </Row>
              </>
            )}
          </>
        </Container>
      )}
    </>
  );

  function prePage() {
    if (currentPage > 1) {
      // Check if there's a previous page
      setCurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage < npage) {
      // Check if there's a next page
      setCurrentPage(currentPage + 1);
    }
  }
};

export default PassportList;
